import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./cookies.component.scss']
})
export class CookiesComponent implements OnInit {

  isAcceptCookies: boolean;
  constructor() { }


  ngOnInit(): void {
    if (localStorage.getItem('cookieAccepted')) {
      this.isAcceptCookies = true;
    }
  }


  acceptCookies(isAccept: boolean) {
    if (isAccept) {
      localStorage.setItem('cookieAccepted', 'true')
    }
    this.isAcceptCookies = true;
  }
}
